<span class="truncate-middle" #targetContainer>
  <ng-container *ngIf="content$ | async as content">
    <span class="start">
      {{ start }}
    </span>
    <span class="end" *ngIf="end">
      {{ end }}
    </span>
  </ng-container>
</span>
<div
  (cdkObserveContent)="onContentChange($event)"
  style="visibility: hidden; height: 0; overflow-y: hidden; display: block; line-height: 00"
  #projectedContentContainer
>
  <ng-content></ng-content>
</div>
